var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { CircleCheck, CircleInfo } from "@safetyculture/icons-react";
import Banner from "../../banner/banner";
const notificationIcons = {
    neutral: undefined,
    negative: React.createElement(CircleInfo, null),
    positive: React.createElement(CircleCheck, null),
};
export const Notification = forwardRef((_a, ref) => {
    var { status, direction, onClose, action, children } = _a, rest = __rest(_a, ["status", "direction", "onClose", "action", "children"]);
    return (React.createElement(Banner, Object.assign({}, rest, { role: "alert", ref: ref, icon: notificationIcons[status], direction: direction, closeProps: {
            onClick: onClose,
        }, actionsSlot: action ? [action] : undefined }), children));
});
export default Notification;
